import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title, Form } from 'components/layout'
import { Button, FormButton } from 'components/misc'
import { form } from 'helpers/decorators'
import { FormattedMessage, FormattedPlural, injectIntl } from 'react-intl'
import { apiMessages } from 'helpers/decorators/api'
import { RichTextArea } from 'components/richtext'
import { FormattedDate, FormattedTime } from '../../intl'
import styles from './add-message-modal.styl'
import moment from 'moment'
import { get } from 'lodash'

@apiMessages({
  list: false
})
@form({
  form: 'addMessage',
  disableHook: true
})
@injectIntl
class AddMessageModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    modalId: PropTypes.string,
    intl: PropTypes.object.isRequired,
    awardId: PropTypes.number.isRequired,
    sendAsPushNotification: PropTypes.bool,
    sendAsEmail: PropTypes.bool,
    activityLog: PropTypes.object.isRequired,
    addMessage: PropTypes.func,
    modal: PropTypes.func,
    values: PropTypes.object,
    reset: PropTypes.func,
    initialize: PropTypes.func.isRequired,
    getActivityLog: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    formLocked: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    onLockForm: PropTypes.func.isRequired
  }

  static defaultProps = {
    sendAsPushNotification: true,
    sendAsEmail: false
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.formLocked !== nextProps.formLocked ||
      this.props.pristine !== nextProps.pristine ||
      this.props.activityLog.id !== nextProps.activityLog.id
    )
  }

  handleCreateMessage = fields => {
    this.props.onLockForm(true)
    const awardId = this.props.awardId

    const activityLogId = get(this.props, 'activityLog.id')

    const activityId = get(this.props, 'activityLog.activity.id')

    const sendAsPushNotification = this.props.sendAsPushNotification

    const sendAsEmail = this.props.sendAsEmail

    this.props.addMessage({ awardId, activityLogId, activityId, sendAsPushNotification, sendAsEmail, fields })
      .then(() => {
        this.props.getActivityLog()
        this.props.reset()
      })
      .catch(error => {
        console.log(error)
        this.props.onLockForm(false)
      })
  }

  handleCloseModal = () => {
    this.props.reset()
    this.props.modal(null)
  }

  render() {
    const {
      modalId,
      handleSubmit,
      activityLog,
      intl,
      formLocked,
      pristine
    } = this.props

    const time = moment.duration(activityLog.duration, 'seconds')

    const hours = Math.floor(time.asHours())

    const mins = Math.floor(time.asMinutes()) - hours * 60

    return (
      <Modal id={modalId} customActions>
        <Title h2 intlKey="moduleTitle.send_message">
         Send a message or comment to this log
        </Title>

        <div className={styles.messageLog} >
          <div className={styles.header}>
            <div className={styles.time}>
              {activityLog.date && <FormattedDate value={activityLog.date} spaceAfter />}{' '}
              <span className={styles.duration}>
                          {hours}{' '}
                <FormattedPlural
                    value={hours}
                    one={intl.formatMessage({
                      id: 'logs.hour',
                      defaultMessage: 'hour',
                    })}
                    other={intl.formatMessage({
                      id: 'logs.hours',
                      defaultMessage: 'hours',
                    })}
                />{' '}
                &nbsp;
                {mins}{' '}
                <FormattedPlural
                    value={mins}
                    one={intl.formatMessage({
                      id: 'logs.minute',
                      defaultMessage: 'minute',
                    })}
                    other={intl.formatMessage({
                      id: 'logs.minutes',
                      defaultMessage: 'minutes',
                    })}
                />
                </span>

            </div>
            <div className={styles.created}>
              {activityLog.createdAt && (
                  <div>
                    <FormattedMessage id="label.created_at" defaultMessage="Created at" />
                    : <FormattedDate timeZone="utc" value={activityLog.createdAt} spaceAfter />{' '}
                    <FormattedTime timeZone="utc" value={activityLog.createdAt} />
                  </div>
              )}
            </div>
          </div>
          <div className={styles.footer}>
            <p className={styles.description}><i>{activityLog.description}</i></p>
          </div>
        </div>


        <Form
          className="form"
          onSubmit={handleSubmit(this.handleCreateMessage)}
        >
          <div className="row" />

          <RichTextArea
            label="Message"
            intlKey="label.message"
            name="content"
            isInitialized={false}
          />

          <div className="row">
            <div className="col-xs-6">
              <Button
                intlKey="button.cancel"
                onClick={() => this.handleCloseModal()}
                secondary
                type="button"
                style={{ marginRight: 10 }}
              >
                Cancel
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <FormButton
                {...this.props}
                intlKey="button.send"
                disabled={formLocked}
                pristine={pristine}
              >
                Send
              </FormButton>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default AddMessageModal
